module.exports = __webpack_public_path__ + "img/Banat_Bf_kl.6b9dd70e.jpg";